import type {
	Form,
	GeneralSetupTranslations,
	Mutation,
	Shared,
} from "Infrastructure/Translation/Types/generalSetup";

const mutationTranslations: Mutation = {
	updateGeneralSetupError: "Failed to update general setup. Please try again.",
	updateGeneralSetupSuccess: "General setup updated successfully.",
};

const formTranslations: Form = {
	save: "Save",
	adamServiceFeePercentage: "Adam service fee percentage",
	adamServiceFeeVatPercentage: "Adam service fee VAT percentage",
	customerVATPercentage: "Customer VAT percentage",
	depositLimitAmount: "Deposit limit amount",
	staticDepositAmount: "Static deposit amount",
	staticDepositAmountHelper:
		"Charged when order total is below the deposit limit.",
	depositPercentage: "Deposit percentage",
	expresFeePrice: "Expres fee price",
	emailReplyTo: "Reply to email",
};

const sharedTranslations: Shared = {
	generalSetup: "General setup",
	adamServiceFees: "Adam service fees",
	customer: "Customer",
	order: "Order",
	partner: "Partner",
};

export const generalSetupTranslations: GeneralSetupTranslations = {
	mutation: mutationTranslations,
	form: formTranslations,
	shared: sharedTranslations,
};
